// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
const ReportingActions = {
  /* Reports datatable */
  SET_REPORTS_DATATABLE_INFO: 'SET_REPORTS_DATATABLE_INFO',
  SET_REPORTS_DATATABLE_FILTER_INFO: 'SET_REPORTS_DATATABLE_FILTER_INFO',
  RESET_REPORTS_DATATABLE_INFO: 'RESET_REPORTS_DATATABLE_INFO',
  RESET_REPORTS_DATATABLE_FILTER_INFO: 'RESET_REPORTS_DATATABLE_FILTER_INFO',
  /* Reports datatable */

  SET_REPORTS_METADATA: 'SET_REPORTS_METADATA',
  SET_CREATE_REPORTS_API_DATA: 'SET_CREATE_REPORTS_API_DATA',
  SET_DELETE_REPORTS_API_DATA: 'SET_DELETE_REPORTS_API_DATA',
  SET_REPORTS_PREVIEW_DATA: 'SET_REPORTS_PREVIEW_DATA',

  /* Recurring Reports datatable */
  SET_RECURRING_REPORTS_DATATABLE_INFO: 'SET_RECURRING_REPORTS_DATATABLE_INFO',
  SET_RECURRING_REPORTS_DATATABLE_FILTER_INFO:
    'SET_RECURRING_REPORTS_DATATABLE_FILTER_INFO',
  RESET_RECURRING_REPORTS_DATATABLE_INFO:
    'RESET_RECURRING_REPORTS_DATATABLE_INFO',
  RESET_RECURRING_REPORTS_DATATABLE_FILTER_INFO:
    'RESET_RECURRING_REPORTS_DATATABLE_FILTER_INFO'
  /* Recurring Reports datatable */
}
export default ReportingActions
